import { useEffect, useState } from "react";
import { Divider } from "@mui/material";
import {
  NotifyClearCache,
  NotifyDeployCache,
} from "../../../components/notify/Notify";

import Controls from "../../../components/form/controls/Controls";
import {
  clearCacheADB,
  deployCacheADB,
  getCacheADB,
} from "../../../apis/ADB/adb.api";
import useCurrentUserCache from "../../../hooks/useCurrentUserCache";
import useAuth from "../../../hooks/useAuth";
import { currentUserHandleCache } from "../../../utils/helper";
import { allowedDeployCache } from "../../../constants/role";

const importCache = ({ listDataCache, localUser, currentUserCache }) => {
  return (
    <div>
      <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
        {currentUserHandleCache(localUser, currentUserCache)}
        {`vừa tạo địa giới hành chính gồm:`}
      </p>
      {listDataCache.map((data, index) => (
        <p
          key={index}
          style={{ padding: "10px", fontWeight: "bold", color: "#0069A9" }}
        >
          {`${data.count} ${data.name}`}
        </p>
      ))}
    </div>
  );
};

const objectActionCache = {
  Import: importCache,
};

const RenderCache = ({
  listDataCache,
  actionCache,
  localUser,
  currentUserCache,
}) => {
  if (actionCache) {
    return objectActionCache[actionCache]({
      listDataCache,
      localUser,
      currentUserCache,
    });
  }
  return null;
};

const ShowCacheADB = ({ disableButton, setDisableButton }) => {
  const [listDataCache, setListDataCache] = useState([]);
  const [modelCache, setModelCache] = useState();
  const [actionCache, setActionCache] = useState();

  const { currentUserCache } = useCurrentUserCache();

  const { auth } = useAuth();

  useEffect(() => {
    getCacheADB((result) => {
      setListDataCache(result.data);
      setModelCache(result.model);
      setActionCache(result.action);
    });
  }, []);

  const handleDeployData = () => {
    NotifyDeployCache(
      "warning",
      "Deploy Data ?",
      "<h5> Tất cả dữ liệu mới sẽ được lưu </h5>",
      (result) => {
        if (result.isConfirmed) {
          setDisableButton(true);
          deployCacheADB((result) => {
            window.location.reload(true);
            setDisableButton(false);
          });
        }
      }
    );
  };

  const handleClearData = () => {
    NotifyClearCache(
      "warning",
      "Clear Cache ?",
      "<h5> Tất cả dữ liệu mới sẽ được hủy bỏ </h5>",
      (result) => {
        if (result.isConfirmed) {
          setDisableButton(true);
          clearCacheADB((result) => {
            window.location.reload(true);
            setDisableButton(false);
          });
        }
      }
    );
  };

  return (
    <>
      <RenderCache
        listDataCache={listDataCache}
        modelCache={modelCache}
        actionCache={actionCache}
        localUser={auth}
        currentUserCache={currentUserCache}
      />
      <Divider sx={{ width: "100%" }} />
      {allowedDeployCache(
        currentUserCache?.email,
        auth?.email,
        auth?.permissions
      ) ? (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          {disableButton && (
            <h3
              style={{
                marginTop: "10px",
                paddingTop: "10px",
                marginRight: "20px",
                color: "red",
              }}
            >
              Deploying data
            </h3>
          )}
          <Controls.Button
            sx={{
              width: "170px",
              marginTop: "10px",
            }}
            color="secondary"
            type="button"
            disabled={disableButton}
            isLoading={disableButton}
            text="Clear Cache"
            onClick={handleClearData}
          />
          <Controls.Button
            sx={{ width: "170px", marginTop: "10px", marginLeft: "10px" }}
            type="button"
            isLoading={disableButton}
            disabled={disableButton}
            text="Deploy Data"
            onClick={handleDeployData}
          />
        </div>
      ) : null}
    </>
  );
};

export default ShowCacheADB;
